import { t } from '../../../../../../common/i18n.js'
import type { Language } from '../../../../../../common/types/i18n.js'
import type { EatDebtPayload } from '../../../../../../server/controllers/portal/dashboard-card-payloads.js'

/**
 * Temporary placeholder: the gotoAndEat data migration isn't done yet, so the
 * card shows "Coming soon" instead of a (meaningless) debt total. Restore the
 * conditional debt rendering once orders are migrated.
 */
export const EatDebtCard = ({ lang }: { data: EatDebtPayload; lang: Language }) => {
    const c = t.portal.dashboard.cards.eat_debt
    return <span className="portal-card__empty">{c.comingSoon(lang)}</span>
}
